export default {
  label: {
    en: 'Select',
  },
}
